const Footer = () =>
{
    return (
        <>
            <div className="clearfix"></div>
            <footer>
                <div className="main-footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 footer-item">
                                <img src="assets/images/brand/logo-iai-footer.png" height="110px" alt=""/>
                            </div>
                            <div className="col-md-3 footer-item">
                            </div>
                            <div className="col-md-6 footer-item">
                                <ul className="social-network ">
                                    <li><a href="#"><span className="fa fa-facebook"></span></a></li>
                                    <li><a href="#"><span className="fa fa-linkedin"></span></a></li>
                                </ul>
                                <br/> <br/>
                                <p className="title-footer">Brazzaville, CONGO</p>
                                <p className='mentions'>
                                    <a href="mailto:contact@association-iaicongo.org">contact@association-iaicongo.org</a>
                                    <br/>
                                    <a href="tel:242068389195">+242 06 838 91 95</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sub-footer">
                    {(new Date()).getFullYear()} &copy; Copyright - Tous les droits reservés
                </div>
            </footer>
        </>
    );
}

export default Footer;